angular
  .module('ui-ng-calendar-time')
  .controller('ListCalendarTimeController', function ($scope) {
    $scope.onTimeChanged = function onTimeChanged(time, timeProperty) {
      if (!_.isUndefined(time[timeProperty + 'Input'])) {
        var hour = time[timeProperty + 'Input'].getHours();
        var minutes = time[timeProperty + 'Input'].getMinutes();

        time[timeProperty] = moment(hour + ':' + minutes + ':00', 'HH:mm:ss');
      }
    };

    $scope.onDayChanged = function onDayChanged(time) {};

    $scope.preserveLastEmptyTime = function preserveLastEmptyTime() {
      if (_.isEmpty($scope.times) || !!_.last($scope.times).day) {
        $scope.addEmptyTime();
        $scope.whenUpdated({ times: $scope.times });
      }
    };
  })
  .directive('listCalendarTime', function calendarWeek() {
    'use strict';

    return {
      restrict: 'E',
      require: '^calendarTime',
      replace: false,
      scope: false,
      controller: 'ListCalendarTimeController',
      templateUrl: 'ui-ng-calendar-time/src/components/list_calendar_time/list_calendar_time.html',
      link: function (scope, element, attrs) {
        element.addClass('list-calendar-time');
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar-time/src/components/list_calendar_time/list_calendar_time.js